import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    CQuotesTab,
} from 'app/enums/domain.enums'
import requests from 'app/requests/CQuote/CQuote.requests'
import tableConfig from './CQuotes.config'
import CQuoteCreateSelectMethod from './CQuoteCreateSelectMethod'
import CQuoteOverview from './CQuoteOverview'
import CQuotesAwardRejectLanes from './CQuotesAwardRejectLanes'
import CQuotesPDF from './CQuotesPDF'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

export default function CQuotes() {
    const accountCreate = useHasPermission(['account_create_all'])

    const accountUpdate = useHasPermission(['account_update_all'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: CQuoteOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Award/Reject',
                url: CQuotesTab.AwardReject,
                Component: CQuotesAwardRejectLanes,
                activeComparer: (pathname) => {
                    return pathname.split('/').includes(CQuotesTab.AwardReject)
                },
            },
            permission: accountUpdate,
        },
        {
            tab: {
                label: 'Quote PDF',
                url: CQuotesTab.QuotePdf,
                Component: CQuotesPDF,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            name={tableConfig.name}
            sidebarTabs={tabs}
            defaultTab={CommonRoutes.Overview}
            actionComponents={{
                Create: accountCreate ? CQuoteCreateSelectMethod : null,
            }}
        >
            <SkyNetTable
                customUrl={requests[RequestKeys.cQuotesFilterRequest]().url}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}
